import { Vue } from '~/utils/nuxt3-migration'
// @ts-ignore
import vClickOutside from 'v-click-outside'

Vue.use(vClickOutside)
